module.exports = __webpack_public_path__ + "static/media/5.1ae0b833.jpg";